import React, { Component } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { injectIntl, FormattedMessage } from 'react-intl';
import Button from '@/shared/components/Button';

import messages from './documentTemplateMessages';
import config from '@/config';
import SecureImage from '@/shared/components/SecureImage';

class PreviewDocumentTemplateModal extends Component {
  state = {};

  componentDidMount() {
    const { templateId } = this.props;

    this.setState({
      url: `${
        config.appUrls.api
      }/api/documentTemplate/PreviewTemplate/${templateId}?now=${new Date().getTime()}`,
    });
  }

  render() {
    const { onClose } = this.props;
    const { url, error } = this.state;
    return (
      <Modal
        backdrop="static"
        show
        onHide={() => onClose(null)}
        keyboard={false}
        dialogClassName="modal-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage {...messages.Preview} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body scrollable text-center">
            {url && !error && (
              <SecureImage
                src={url}
                onError={() => this.setState({ error: true })}
                className="img-responsive"
              />
            )}
            {error && (
              <label>
                <FormattedMessage {...messages.ErrorWhileLoadingPreview} />
              </label>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => onClose(null)}>
            <FormattedMessage {...messages.Close} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default injectIntl(PreviewDocumentTemplateModal);
